// extracted by mini-css-extract-plugin
module.exports = {"tabbed":"TabGroup-module--tabbed--35S5P","tabViewsContainer":"TabGroup-module--tabViewsContainer--qcqsV"};